module.exports = __webpack_public_path__ + "img/bt-logo.f08e0864.svg";